(() => {
  const NEW_TEXT = 'Checkout with other payment methods';

  const updatePaymentOptionsText = (root = document) => {
    root.querySelectorAll('.shopify-payment-button__more-options').forEach((button) => {
      const current = (button.textContent || '').trim();
      if (current !== NEW_TEXT) {
        button.textContent = NEW_TEXT;
        button.setAttribute('aria-label', NEW_TEXT);
      }
    });
  };

  const start = () => {
    updatePaymentOptionsText();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('.shopify-payment-button__more-options')) {
            updatePaymentOptionsText(node.parentElement || document);
          } else if (node.querySelector?.('.shopify-payment-button__more-options')) {
            updatePaymentOptionsText(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
